module.exports = __webpack_public_path__ + "img/app_thumbnail-600x450.f0c71578.jpg";